import type { ConfigurationProvider } from './index'

export default {
    basePublicPath: 'https://collaboratori.facile.it/cbr/',
} as ConfigurationProvider.Configuration
